import logoSvg from 'assets/logos/logo.svg';
import React from 'react';

export default function Logo() {
  return <img src={logoSvg} alt="Pitstop Logo" />;
}
